import { ArrowLeftOutlined } from "@ant-design/icons";
import "./HeaderBackToGate.css";

const GATE_URL =
  process.env.REACT_APP_GATE_URL || "http://localhost:10361/dashboard";

function parseJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const payload = token.split(".")[1];
    if (!payload) {
      return null;
    }
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(normalized)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

function HeaderBackToGate() {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) {
    return null;
  }

  const payload = parseJwtPayload(accessToken);
  if (!payload?.loginViaGate) {
    return null;
  }

  const handleClick = () => {
    const returnUrl = localStorage.getItem("gateReturnUrl");
    window.location.href =
      returnUrl && /^https?:\/\//i.test(returnUrl) ? returnUrl : GATE_URL;
  };

  return (
    <div className="header-back-to-gate">
      <button
        type="button"
        className="header-back-to-gate__btn"
        onClick={handleClick}
        aria-label="GATE'e geri dön"
      >
        <ArrowLeftOutlined className="header-back-to-gate__icon" aria-hidden />
        <span className="header-back-to-gate__label header-back-to-gate__label--full">
          GATE&apos;e geri dön
        </span>
        <span className="header-back-to-gate__label header-back-to-gate__label--short">
          GATE
        </span>
      </button>
    </div>
  );
}

export default HeaderBackToGate;
